(() => {
  'use strict';
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-hsx2-menu]').forEach(menu => {
      menu.querySelectorAll('a').forEach(link => {
        if (link.dataset.hsxMenuBound) return;
        link.dataset.hsxMenuBound = 'true';
        link.addEventListener('click', () => { menu.open = false; });
      });
    });
  };
  document.addEventListener('shopify:section:load', event => bind(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(), {once:true});
  else bind();
})();

/* Blend only the first homepage hero with its header; never change other pages. */
(() => {
  'use strict';
  const heroSelector = '#MainContent > .hsx-v2-hero-section:first-child > .hsx-v2-hero--immersive';
  const solidPreference = window.matchMedia('(prefers-reduced-transparency: reduce), (prefers-contrast: more), (forced-colors: active)');
  let wrapper = null;
  let header = null;
  let frame = 0;

  const update = () => {
    frame = 0;
    if (!header?.isConnected || !wrapper?.isConnected) return;
    const height = `${Math.ceil(wrapper.getBoundingClientRect().height)}px`;
    if (document.body.style.getPropertyValue('--hsx2-home-header-height') !== height) {
      document.body.style.setProperty('--hsx2-home-header-height', height);
    }
    const atTop = window.scrollY <= 16 && !solidPreference.matches && !header.querySelector('[data-hsx2-menu][open]');
    const value = String(atTop);
    if (header.dataset.hsxHomeTop !== value) header.dataset.hsxHomeTop = value;
  };
  const schedule = () => {
    if (header && !frame) frame = window.requestAnimationFrame(update);
  };
  const observer = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;

  const mount = () => {
    if (frame) window.cancelAnimationFrame(frame);
    frame = 0;
    observer?.disconnect();
    if (header) delete header.dataset.hsxHomeTop;
    delete document.body.dataset.hsxHomeHero;
    document.body.style.removeProperty('--hsx2-home-header-height');
    wrapper = null;
    header = null;
    if (!document.querySelector(heroSelector)) return;
    wrapper = document.querySelector('.hsx-v2-header-section');
    header = wrapper?.querySelector('.hsx-v2-header') || null;
    if (!header) return;
    document.body.dataset.hsxHomeHero = 'true';
    update();
    observer?.observe(wrapper);
  };

  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', mount);
  solidPreference.addEventListener?.('change', schedule);
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-hsx2-menu]')) schedule();
  }, true);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => {
    document.addEventListener(name, () => window.requestAnimationFrame(mount));
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, {once: true});
  } else {
    mount();
  }
})();

